import { Box } from '@mui/material';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { AgGridReact } from 'ag-grid-react';
import { Dispatch, SetStateAction } from 'react';
import { PendingRespondent, PendingRespondentStatusMap, SearchParams } from 'src/@types/pendingRespondentStatus';
import useTheme from 'src/hooks/useTheme';
import { useIdIssuanceManagementGrid } from './hooks/useIdIssuanceManagementGrid';
import { Action } from './utils/searchState';

type IdIssuanceManagementGridProps = {
  rowData: PendingRespondent[];
  statusMap: PendingRespondentStatusMap;
  setSelectedUser: Dispatch<SetStateAction<PendingRespondent | undefined>>;
  fetchPendingRespondents: (searchParams: SearchParams) => Promise<void>;
  searchParams: SearchParams;
  dispatch: Dispatch<Action>;
};

export const IdIssuanceManagementGrid = ({
  rowData,
  statusMap,
  setSelectedUser,
  fetchPendingRespondents,
  dispatch,
  searchParams,
}: IdIssuanceManagementGridProps) => {
  const { className } = useTheme();
  const { columnDefs, defaultColDef, onRowClicked, onGridReady, onSortChanged } = useIdIssuanceManagementGrid({
    statusMap,
    setSelectedUser,
    fetchPendingRespondents,
    dispatch,
    searchParams,
  });

  return (
    <Box className={className} style={{ height: 600, width: '100%' }}>
      <AgGridReact<PendingRespondent>
        rowData={rowData}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        onSortChanged={onSortChanged}
        onRowClicked={onRowClicked}
        onGridReady={onGridReady}
        allowContextMenuWithControlKey={true}
        suppressContextMenu={true}
        rowStyle={{ cursor: 'pointer' }}
      />
    </Box>
  );
};
